import { AuthUser } from '../context/AuthContext';

export type AuthRole = AuthUser['role'];

export function defaultRouteForRole(role: AuthRole) {
  if (role === 'system') return '/sistema';
  if (role === 'admin') return '/';
  return '/procedimentos';
}

export function isSafeInternalPath(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  const path = value.trim();
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.includes('\\')) return false;
  return true;
}

export function loginDestination(user: Pick<AuthUser, 'role'>, requestedPath?: unknown) {
  if (isSafeInternalPath(requestedPath)) return requestedPath.trim();
  return defaultRouteForRole(user.role);
}
